var map = {
	"./baby-leggings@2x.jpg": 53988,
	"./basic-tote@2x.jpg": 72092,
	"./beanies-youth@2x.jpg": 29476,
	"./bedroom@2x.jpg": 96023,
	"./blanket@2x.jpg": 75464,
	"./bottles-and-tumblers@2x.jpg": 40543,
	"./boxer-briefs@2x.jpg": 41776,
	"./boyshorts@2x.jpg": 5246,
	"./cheeky-briefs@2x.jpg": 18586,
	"./cotton-fabrics@2x.jpg": 14348,
	"./cotton-market-tote@2x.jpg": 98324,
	"./day-tote@2x.jpg": 99924,
	"./desk-mat@2x.jpg": 55617,
	"./drawstring-bag@2x.jpg": 41663,
	"./dresses@2x.jpg": 38056,
	"./face-coverings@2x.jpg": 23765,
	"./headwear@2x.jpg": 59614,
	"./hemp-fabrics@2x.jpg": 98834,
	"./hoodies@2x.jpg": 20954,
	"./kitchen@2x.jpg": 56995,
	"./large-basic-cotton-tote@2x.jpg": 63594,
	"./large-basic-tote@2x.jpg": 75962,
	"./large-notebooks@2x.jpg": 4463,
	"./leggings-and-pants@2x.jpg": 5652,
	"./living-room@2x.jpg": 54328,
	"./long-sleeve-shirts@2x.jpg": 27526,
	"./makeup-bags@2x.jpg": 10022,
	"./market-totes@2x.jpg": 39477,
	"./office@2x.jpg": 56859,
	"./origami-tote@2x.jpg": 55000,
	"./performance-polyester-fabrics@2x.jpg": 28718,
	"./permanent-sticker@2x.jpg": 43219,
	"./pillow-cases@2x.jpg": 22750,
	"./robes@2x.jpg": 84688,
	"./scarves@2x.jpg": 1526,
	"./scoop-bralette@2x.jpg": 48831,
	"./seasonal@2x.jpg": 77715,
	"./shorts@2x.jpg": 1252,
	"./silk-fabrics@2x.jpg": 55077,
	"./skirts@2x.jpg": 95435,
	"./small-notebooks@2x.jpg": 23931,
	"./spiral-notebooks@2x.jpg": 88577,
	"./stainless-steel-tumbler@2x.jpg": 65191,
	"./stationery-cards@2x.jpg": 24911,
	"./t-shirts@2x.jpg": 38489,
	"./tank-tops@2x.jpg": 70940,
	"./tea-towels@2x.jpg": 13506,
	"./unisex-joggers@2x.jpg": 29211,
	"./urban-tote@2x.jpg": 99082,
	"./vegan-leather-backpack@2x.jpg": 91817,
	"./vegan-leather-crossbody-purse@2x.jpg": 62073,
	"./vegan-leather-makeup-bag@2x.jpg": 36555,
	"./vegan-leather-tote-bag@2x.jpg": 40518,
	"./wall-art@2x.jpg": 48051,
	"./woven-polyester-fabrics@2x.jpg": 99983,
	"./yoga-shorts@2x.jpg": 43379,
	"./youth-leggings@2x.jpg": 82321,
	"./zipper-pouches@2x.jpg": 96283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53495;